import kwelloLogo from 'assets/icons/kwelloLogo.svg?url';
import PropTypes from 'prop-types';

const KwelloLogo = ({ className }) => <img src={kwelloLogo} className={className} />;

KwelloLogo.propTypes = { className: PropTypes.string };
KwelloLogo.defaultProps = { className: null };

export default KwelloLogo;
